export default function Step2(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M11.4384 33C10.3516 29.1131 10.5922 22.8037 20.4732 24.5684C20.5483 24.5818 20.6272 24.5536 20.6733 24.4929C22.9212 21.5312 28.0265 17.8263 31.1936 25.8102C31.2359 25.9169 31.3602 25.9732 31.4665 25.9298C33.2984 25.1826 37.048 24.6184 39.2195 27.6218C39.3187 27.7591 39.5412 27.7343 39.606 27.5778C40.334 25.8189 42.3451 23.1639 45.7434 24.1175C49.2013 25.0877 49.6313 27.6189 49.3945 28.9639C49.3731 29.0856 49.4563 29.2038 49.5794 29.2148C51.1135 29.3528 53.3344 29.6552 52.4384 33"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <rect x="7" y="33" width="49" height="8" rx="4" stroke="black" strokeWidth="3" />
            <path
                d="M12.2925 42.2312C12.1432 41.6029 12.6197 41 13.2654 41H50.744C51.3867 41 51.8626 41.5977 51.7185 42.2241L48.2696 57.2241C48.1652 57.6782 47.761 58 47.295 58H16.8293C16.3661 58 15.9635 57.6818 15.8564 57.2312L12.2925 42.2312Z"
                stroke="black"
                strokeWidth="3"
            />
            <path
                d="M36.926 6.40377C36.9971 6.2469 37.22 6.24731 37.2906 6.40444L39.129 10.4996C39.1453 10.536 39.1722 10.5667 39.2061 10.5877L43.0199 12.9517C43.1458 13.0298 43.1461 13.2129 43.0205 13.2914L39.1851 15.6863C39.1522 15.7068 39.126 15.7365 39.1097 15.7716L37.2447 19.7799C37.1729 19.9344 36.9531 19.934 36.8818 19.7792L35.0426 15.7878C35.0262 15.7522 34.9997 15.7222 34.9664 15.7015L31.1516 13.3369C31.0257 13.2589 31.0254 13.0758 31.1511 12.9973L34.9855 10.6029C35.019 10.582 35.0455 10.5517 35.0618 10.5158L36.926 6.40377Z"
                stroke="black"
                strokeWidth="2.5"
            />
        </svg>
    );
}
